import { call, put, select } from 'redux-saga/effects';
import { getFormValues } from 'redux-form/immutable';
import { push } from 'redux-little-router';
import { SimplifiedDeductionFormSteps } from '../constants';
import { submitDataFailure, submitSuccess } from '../redux/actions';
import postData from '../services/postData';

export function* submitSaga({ payload: { statementId, step } }) {
  const formData = yield select(getFormValues(SimplifiedDeductionFormSteps.step1));
  const { isOk, data, error } = yield call(postData, { notificationData: formData.toJS() });
  if (isOk && data) {
    yield put(submitSuccess(data));
    yield put(push({ query: { statementId, step } }));
  } else {
    yield put(submitDataFailure(error));
  }
}
